import Logo from "@/components/Logo";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#FAFAFA] flex flex-col">
      <div className="grain" />
      <div className="px-6 lg:px-8 h-20 flex items-center max-w-7xl mx-auto w-full">
        <Link to="/" data-testid="forgot-logo" aria-label="MBM home"><Logo className="h-7 w-auto" /></Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-md" data-testid="forgot-page">
          <div className="section-label text-[10px] text-[#9fd3ff]">Account recovery</div>
          <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-light tracking-tight">Reset your password.</h1>
          {sent ? (
            <div className="mt-8 glass-card p-8" data-testid="forgot-sent">
              <p className="text-sm text-zinc-300 font-light leading-relaxed">
                If an account exists for <span className="text-white">{email}</span>, we've sent a password reset
                link. Please check your inbox (and spam). The link is valid for 1 hour.
              </p>
              <Link to="/login" className="mt-6 inline-block text-[#9fd3ff] hover:text-white text-sm transition-colors" data-testid="forgot-back-login">
                Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <p className="mt-3 text-sm text-zinc-500 font-light">
                Enter your email and we'll send you a secure link to set a new password.
              </p>
              <form onSubmit={submit} className="mt-10 space-y-5" data-testid="forgot-form">
                <div>
                  <label className="section-label text-[9px] text-zinc-500">Email</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                    className="mt-2 w-full bg-transparent border border-white/15 focus:border-[#6ea8ff]/60 rounded-lg px-4 py-3 text-sm outline-none transition-colors"
                    data-testid="forgot-email" />
                </div>
                {error && <div className="text-sm text-red-400 font-light" data-testid="forgot-error">{error}</div>}
                <button type="submit" disabled={busy}
                  className="btn-solid w-full py-3.5 text-sm font-medium tracking-wide disabled:opacity-50" data-testid="forgot-submit">
                  {busy ? "Sending…" : "Send reset link"}
                </button>
              </form>
              <div className="mt-8 text-sm text-zinc-500 font-light">
                Remembered it? <Link to="/login" className="text-[#9fd3ff] hover:text-white transition-colors" data-testid="forgot-login-link">Sign in</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
